import React from 'react'

import { Form, Col } from '_zari/core'

import { EstadosOSE } from 'constants/index'

const EstadoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='input-estado' md={4} />
      <Col md={8}>
        <Form.Select name='selectEstado' value={value} onChange={onChange} id='input-estado'>
          <option value=''>TODOS</option>
          {EstadosOSE.__array.map((x, k) => (
            <option key={k} value={x.id}>
              {x.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default EstadoFormGroup
